// Shared map for admin-generated Pro/Team payment links. The admin endpoint mints
// an auto-login link ending in `?upgrade=<key>`; the default layout reads that key
// and opens the pricing popup pre-selected to the matching plan/interval.
export type PlanLinkKey = 'member-monthly' | 'member-annual' | 'pro-monthly' | 'pro-annual' | 'team';

export const PLAN_LINK_MAP: Record<PlanLinkKey, { plan: 'MEMBER' | 'PRO' | 'TEAM'; interval: 'MONTHLY' | 'ANNUAL' }> = {
  'member-monthly': { plan: 'MEMBER', interval: 'MONTHLY' },
  'member-annual': { plan: 'MEMBER', interval: 'ANNUAL' },
  'pro-monthly': { plan: 'PRO', interval: 'MONTHLY' },
  'pro-annual': { plan: 'PRO', interval: 'ANNUAL' },
  team: { plan: 'TEAM', interval: 'ANNUAL' },
};

export const isPlanLinkKey = (v: unknown): v is PlanLinkKey =>
  typeof v === 'string' && Object.prototype.hasOwnProperty.call(PLAN_LINK_MAP, v);
